import React, {PropTypes as T} from 'react';
import {ModalContent} from '../../common/modal';
import InfoHeader from '../../common/modal/closeable_info_header';
import TU from '../../common/tu';
import translate from '../../../utils/translate';
import withDevice from '../../common/withDeviceHOC';
import request from 'superagent';
import ReCAPTCHA from 'react-google-recaptcha';

class Recaptcha extends React.Component {
  static propTypes = {
    onClose: T.func,
    siteKey: T.string,
    verifyEndpoint: T.string,
    onSuccess: T.func,
    isMobile: T.bool
  };

  getGrecaptcha = () => {
    if (window && window.grecaptcha) {
      return window.grecaptcha;
    }
  };

  onChange = (key) => {
    if (typeof key === 'string' && key.length > 0) {
      const requestData = {
        recaptchaToken: key
      };
      request
          .post(this.props.verifyEndpoint)
          .type('form')
          .send(requestData)
          .end(this.props.onSuccess);
    }
  };

  render () {
    const isMobile = this.props.isMobile;
    const size = isMobile ? 'compact' : 'normal';
    const height = isMobile ? 145 : 75;
    const styles = {
      minHeight: height,
      display: 'flex',
      justifyContent: 'center'
    };

    return (
      <div>
        <InfoHeader onClose={this.props.onClose} title={translate('reCaptchaModule', 'SECURITY_CHECK')} />
        <ModalContent className="recaptcha__modal__content">
          <ReCAPTCHA
            grecaptcha={this.getGrecaptcha()}
            size={size}
            style={styles}
            ref="recaptcha"
            sitekey={this.props.siteKey}
            onChange={this.onChange}
          />
          <div className="recaptcha__text" >
            {translate('reCaptchaModule', 'NO_ACCESS_AUTOMATED')}
          </div>
          <div className="recaptcha__provided_by">
            <TU text={translate('reCaptchaModule', 'PROVIDED_BY')} />
          </div>
        </ModalContent>
      </div>
    );
  }
}

export default withDevice(Recaptcha);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/recaptcha/recaptcha.js